// Роли — данные установки (GET /admin/roles): названия и список для выбора.

import { useQuery } from "@tanstack/react-query";

import { adminRolesApi } from "./api";
import type { AdminRoleRead } from "./types";

/** Служебные роли интеграций — людям не назначаются. */
const NON_HUMAN_ROLES = new Set(["SYSTEM", "ERP_AGENT"]);

export function useRoles() {
  const q = useQuery({
    queryKey: ["admin", "roles"],
    queryFn: () => adminRolesApi.listRoles(),
    staleTime: 60_000,
  });
  const all: AdminRoleRead[] = q.data ?? [];
  return {
    all,
    assignable: all.filter((r) => !NON_HUMAN_ROLES.has(r.role)),
    label: (code: string) => all.find((r) => r.role === code)?.name ?? code,
  };
}
